export const COPY_DATASET = 'Copy'
